import { Checkbox } from '@pixum/web-checkbox';

interface UploadErrorApplyForEveryXElementsProps {
  numOfErrors: number;
  checked: boolean;
  constants: Record<string, string>;
  onChange: (checked: boolean) => void;
}

export function UploadErrorApplyForEveryXElements({
  numOfErrors,
  checked,
  constants,
  onChange
}: UploadErrorApplyForEveryXElementsProps) {
  const label =
    constants['i18n_upload_for_every_photos']?.replace('%numOfPhotos%', String(numOfErrors)) ?? String(numOfErrors);

  return <Checkbox checked={checked} label={label} onChange={onChange} />;
}
